<template>
  <span>
    <div class="background-wallpaper" style="background-image: url(https://wallpapercave.com/wp/wp6896343.jpg);"></div>
    <section class="spaced">
      <div class="container content  spaced">
        <div class="column c12 text-center spaced">
          <h1>MUSIC</h1>
        </div>
        <div class="column c6 push-center">
          <p class="text-center">
            Welcome to the Patronus Records discography. Buy the music to support our endeavour. Stay tuned for new releases, our artists are creating around the clock!
          </p>
        </div>
      </div>
    </section>
    <section class="spaced">
      <div class="container content flex">
        <div class="text-center filter-container">
          <div class="filter-button" @click="filter('all')">ALL</div>
          <div class="filter-button" @click="filter('Single')">SINGLE</div>
          <div class="filter-button" @click="filter('EP')">EP</div>
          <div class="filter-button" @click="filter('LP')">LP</div>
          <div class="filter-button" @click="filter('Compilation')">COMPILATION</div>
        </div>
      </div>
      <div class="container content">
        <div class="profiles column c12 flex">
          <router-link class="profile column c4 card" v-if="selectedCat === album.album_type.Type || selectedCat === 'all'"
               v-for="album in albums" :key="album.id" :class="'album ' + album.album_type.Type"
               :to="{ name: 'release', params: { id : album.slug }}"
               >
            <div class="card-inner">
              <div class="shade">
                <div class="artwork"
                      v-if="album.AlbumArtwork !== null" :style="'background-image:url(' + album.AlbumArtwork.url + ')'"></div>
                <div class="card-overlay text-left push-middle">
                  <div class="card-content">
                    <i class="fas fa-play-circle player-link"></i>
                    <h2>{{ album.AlbumTitle }} </h2>
                    <h3>
                      <!-- {{ album.album_type.Type }} - -->
                      <span v-for="artist in album.artists" :key="artist.id">
                       {{ artist.name }}
                      </span> {{ album.ArtistOverRide }}
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </section>
  </span>
</template>

<script>
import axios from 'axios'

export default {
  title: 'Patronus Records - Gallery',
  name: 'music',
  data () {
    return {
      albums: [],
      AlbumTypes: [],
      selectedCat: 'all'
    }
  },
  created () {
    axios
      .get('https://admin.patronusrecords.com/albums')
      .then((response) => {
        response.data.sort(function (a, b) { return new Date(b.AlbumRelease) - new Date(a.AlbumRelease) })
        this.albums = response.data
      })
    axios
      .get('https://admin.patronusrecords.com/album-types')
      .then((response) => {
        this.AlbumTypes = response.data
      })
  },
  methods: {
    filter (selection) {
      this.selectedCat = selection
    }
  }
}
</script>
<style scoped>
.artwork {
    width: 100%;
    height: 100%;
    overflow: hidden;
    background-size:contain;
}
</style>



// WEBPACK FOOTER //
// src/pages/music.vue